import type { HistoricAncPrescription } from "$routes/patient/[:patientId]/antenatal-care/_lib/anc-encounters";
import { DispensationStrategy, PrescriptionStatus } from "elephant-web/gql";

export const PRESCRIPTION_STATES = {
  AWAITING_DISPENSE: "ready_to_dispense",
  EXPIRED: "expired",
  DISPENSED: "dispensed",
  PAPER_PRESCRIPTION_ISSUED: "paper_prescription_issued",
  NA: "N/A",
};

export const getPrescriptionDispensationState = (
  prescription: HistoricAncPrescription,
) => {
  const dispensation = prescription.dispensations?.items[0];
  const status = prescription.status;

  if (!prescription || !dispensation) {
    return PRESCRIPTION_STATES.NA;
  }

  // Check if paper prescription was issued
  if (
    dispensation.dispensationStrategy ===
    DispensationStrategy.IssuedPaperPrescription
  ) {
    return PRESCRIPTION_STATES.PAPER_PRESCRIPTION_ISSUED;
  }

  // Check if prescription was dispensed (has createdAt)
  if (
    dispensation.createdAt &&
    (dispensation.dispensationStrategy ===
      DispensationStrategy.ProvidedIntendedClinicalProduct ||
      dispensation.dispensationStrategy ===
        DispensationStrategy.ProvidedAlternativeClinicalProduct)
  ) {
    return PRESCRIPTION_STATES.DISPENSED;
  }

  // Check if prescription is expired
  if (
    status === PrescriptionStatus.Expired ||
    new Date() > new Date(prescription.stopsAt)
  ) {
    return PRESCRIPTION_STATES.EXPIRED;
  }

  // Check if prescription is awaiting dispense
  if (status === PrescriptionStatus.Active && !dispensation.createdAt) {
    return PRESCRIPTION_STATES.AWAITING_DISPENSE;
  }

  return PRESCRIPTION_STATES.NA;
};
